module.exports = __webpack_public_path__ + "img/tz1.1c31845b.png";